import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import '../style.css';

const offices = [
  ['Denpasar', 'Jl. Buluh Indah No.56, Pemecutan Kaja, Denpasar Utara, Bali 80118'],
  ['Medan', 'GoWork Sinar Mas Land Plaza, Jl. Pangeran Diponegoro No.18, 10th Floor, Medan'],
  ['Bandung', 'Point Lab Co-working Space, Jl. Banda No.30, Citarum, Bandung'],
  ['Jakarta', 'MULA Coworking (CITOS), Jl. TB Simatupang No.17, Cilandak, Jakarta Selatan'],
  ['Tangerang Selatan', 'Sanctuary Coworking Space, Ruko Emerald Boulevard Bintaro Sektor 9 Blok AA2 No.50, Banten'],
  ['Yogyakarta', 'Ruko Yap Square C5, Jl. C. Simanjuntak, Terban, Gondokusuman, Yogyakarta'],
  ['Makassar', 'Bikin Bikin Creative Hub Mall Nipah, Jl. Urip Sumoharjo No.23C, Makassar'],
  ['Surabaya', 'IdeaHub Coworking Space Voza Tower, Jl. Mayjen HR. Muhammad No.31, Surabaya'],
];

const Footer = () => {
  const { t } = useTranslation();
  const year = moment().format('YYYY');

  return (
    <footer className="site-footer">
      <div className="container site-footer__grid">
        <section className="site-footer__contact" aria-labelledby="contact-title">
          <h2 id="contact-title">{t('footer.contact_us')}</h2>
          <a href="https://wa.me/6281238431234">
            <i className="fa-solid fa-phone" aria-hidden="true" />
            6281238431234
          </a>
          <a href="mailto:bizdev@niecindonesia.com">
            <i className="fa-regular fa-envelope" aria-hidden="true" />
            bizdev@niecindonesia.com
          </a>

          <div className="site-footer__social" aria-label={t('footer.social_label')}>
            <a href="https://www.instagram.com/niec_indonesia/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fa-brands fa-instagram" aria-hidden="true" />
            </a>
            <a href="https://id-id.facebook.com/niec.indonesia/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fa-brands fa-facebook-f" aria-hidden="true" />
            </a>
            <a href="https://niecindonesia.com/" target="_blank" rel="noopener noreferrer" aria-label="NIEC website">
              <i className="fa-solid fa-globe" aria-hidden="true" />
            </a>
            <a href="https://www.tiktok.com/@niec_indonesia?lang=id-ID" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <i className="fa-brands fa-tiktok" aria-hidden="true" />
            </a>
          </div>
        </section>

        <section className="site-footer__offices" aria-labelledby="offices-title">
          <h2 id="offices-title">NIEC Indonesia</h2>
          <div className="office-grid">
            {offices.map(([city, address]) => (
              <article className="office" key={city}>
                <h3>{city}</h3>
                <p>{address}</p>
              </article>
            ))}
          </div>
        </section>
      </div>

      <div className="site-footer__copyright">
        <p>Copyright &copy; {year} NIEC Indonesia</p>
      </div>
    </footer>
  );
};

export default Footer;
